module.exports = __webpack_public_path__ + "47e7c58d3c3fa068cda8aff084ffc8ac.MP3";